import { useEffect, useState } from "react";
import { PageHeader, EmptyState } from "@/components/ui-bits";
import { Library } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function MyCourses() {
  const { user } = useAuth();
  const [courses, setCourses] = useState([]);
  const [batches, setBatches] = useState([]);

  useEffect(() => {
    api.get("/courses").then(r => setCourses(r.data));
    api.get("/batches").then(r => setBatches(r.data));
  }, []);

  const myBatch = batches.find(b => b.id === user?.batch_id);
  const myCourses = myBatch ? courses.filter(c => c.id === myBatch.course_id) : courses;

  return (
    <div>
      <PageHeader title="My Courses" subtitle={myBatch ? `Enrolled in ${myBatch.batch_name}` : "Browse available courses."} />
      {myCourses.length === 0 ? <EmptyState title="No courses yet" hint="Talk to your admin to be enrolled." /> : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {myCourses.map(c => (
            <div key={c.id} data-testid={`student-course-${c.id}`} className="bg-white border border-slate-200 rounded-xl p-6">
              <div className="w-10 h-10 rounded-lg bg-blue-50 text-blue-600 grid place-items-center">
                <Library className="w-5 h-5" />
              </div>
              <div className="mt-4 text-lg font-semibold text-slate-900">{c.course_name}</div>
              <p className="text-sm text-slate-600 mt-1">{c.description || "—"}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
